import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  ChangeDetectorRef
} from '@angular/core';

import { TabComponent } from './tab/tab.component';

@Component({
  selector: 'db-tab-set',
  templateUrl: './tab-set.component.html',
  styleUrls: ['./tab-set.component.scss']
})

export class TabSetComponent implements AfterContentInit {
  @ContentChildren(TabComponent, { descendants: true })
  tabs: QueryList<TabComponent>;

  tabsArray: TabComponent[] = [];

  constructor(private cdr: ChangeDetectorRef) { }

  ngAfterContentInit() {
    this.updateTabsArray();
    
    // Listen for changes in the tabs
    this.tabs.changes.subscribe(() => {
      this.updateTabsArray();
    });
  }

  private updateTabsArray() {
    this.tabsArray = this.tabs ? this.tabs.toArray() : [];
    this.cdr.detectChanges();
  }

}
